import { spanFromRegExpMatch } from '../spans';
import type { ExtractorOutput } from './types';
import type { MatchSpan } from '../types';

interface FeatureRule {
  field: 'garage' | 'pool' | 'fireplace' | 'waterfront' | 'openHouse';
  pattern: RegExp;
  ruleId: string;
}

const FEATURE_RULES: ReadonlyArray<FeatureRule> = [
  { field: 'garage', pattern: /\bgarage\b/gi, ruleId: 'features.garage' },
  { field: 'pool', pattern: /\b(?:pool|swimming\s+pool)\b/gi, ruleId: 'features.pool' },
  { field: 'fireplace', pattern: /\bfireplaces?\b/gi, ruleId: 'features.fireplace' },
  {
    field: 'waterfront',
    pattern: /\b(?:waterfront|lakefront|oceanfront|beachfront)\b/gi,
    ruleId: 'features.waterfront',
  },
  { field: 'openHouse', pattern: /\bopen\s+house\b/gi, ruleId: 'features.openHouse' },
];

export function extractFeatures(query: string): ExtractorOutput {
  const partial: ExtractorOutput['partial'] = {};
  const spans: MatchSpan[] = [];

  for (const rule of FEATURE_RULES) {
    rule.pattern.lastIndex = 0;
    const match = rule.pattern.exec(query);
    if (!match) continue;
    partial[rule.field] = true;
    spans.push(
      spanFromRegExpMatch(query, match, rule.field, true, {
        confidence: 0.9,
        ruleId: rule.ruleId,
      })
    );
  }

  return { partial, spans };
}
